import { QuickStat } from '../models/quick-stat.model';

export const QUICK_STATS: QuickStat[] = [
  { number: '5K+', label: 'Students' },
  { number: '98%', label: 'Success' },
  { number: '150+', label: 'Schools' }
];
